import React from 'react';
import { Toggle } from '@exxonmobil/react-unity';
import styled from 'styled-components';

interface Props {
  subscription: string;
  setSubscription: (value: string) => void;
}

const costButton = ({ subscription, setSubscription }: Props) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <StyledToggle>
        <StyledToggleItem
          id="toggle-both"
          key="toggle-both"
          name="subscription"
          value="All"
          onChange={(e) => setSubscription(e.target.value)}
          checked={subscription === 'All'}
        >
          ALL
        </StyledToggleItem>
        <StyledToggleItem
          id="toggle-prod"
          key="toggle-prod"
          name="subscription"
          value="Prod"
          onChange={(e) => setSubscription(e.target.value)}
          checked={subscription === 'Prod'}
        >
          PROD
        </StyledToggleItem>
        <StyledToggleItem
          id="toggle-nonprod"
          key="toggle-nonprod"
          name="subscription"
          value="NonProd"
          onChange={(e) => setSubscription(e.target.value)}
          checked={subscription === 'NonProd'}
        >
          NON-PROD
        </StyledToggleItem>
      </StyledToggle>
    </div>
  );
};

const StyledToggle = styled(Toggle)`
  color: #f5f5f5;
  position: absolute;
  transform: scale(0.8); /* Adjust the scale factor as needed */
  transform-origin: right;
  font-family: 'EMprintRegular', serif;
  border-color: #545459;
  .em-is-active {
    background: #545459;
  }
`;

const StyledToggleItem = styled(Toggle.Item)`
  color: #f5f5f5;
  :last-child {
    border-color: #545459;
  }
  border-color: #545459;
`;

export default costButton;
